export const AuthCommand = {
  Logout: 'Auth.logout',
  Configure: 'Auth.configure',
};

export const AuthEvent = {
  AuthError: 'Auth.authError',
  Error: 'Auth.error',
  TokenError: 'Auth.tokenError',
  AuthProviderError: 'Auth.authProviderError',
  Ready: 'Auth.ready',
  Authenticated: 'Auth.authenticated',
  Authenticating: 'Auth.authenticating',
  LoggedOut: 'Auth.loggedOut',
};
